// PR-38 — İçerik oluşturma (post/story) SUNUCU/RULES cooldown ön-talebi.
//
// Akış: UPLOAD BAŞLAMADAN önce rateLimits/{uid}.lastCreateAt yazımını dener.
// Firestore rules o yazımda 15sn cooldown'ı ENFORCE eder (rating velocity
// deseni). permission-denied → cooldown aktif → çağıran upload'ı BAŞLATMAZ.
// Diğer hata (transient/network) → fail-OPEN: meşru kullanıcı kilitlenmez;
// client cooldown + rules yine son kapı. rateLimits AYRI top-level path →
// users/{uid} onWrite trigger'larını TETİKLEMEZ (PR-36 presence maliyeti geri
// gelmez). N+1 yok (yalnız create anında tek yazım; okuma yok).
import { doc, setDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";

export interface CreateSlotResult {
  ok: boolean;
  cooldown?: boolean;
}

export async function claimCreateSlot(uid: string): Promise<CreateSlotResult> {
  if (!uid) return { ok: true };
  try {
    await setDoc(
      doc(db, "rateLimits", uid),
      { lastCreateAt: serverTimestamp() },
      { merge: true },
    );
    return { ok: true };
  } catch (e: any) {
    const code = String(e?.code || e?.message || "").toLowerCase();
    if (code.includes("permission-denied")) return { ok: false, cooldown: true };
    // Transient/başka hata → gate'i geç (fail-open); client cooldown zaten var.
    return { ok: true };
  }
}
